export function extractValidationErrors(error) {
  if (error.response && error.response.data) {
    if(typeof(error.response.data) === 'object')
      return error.response.data
    return { base: [error.response.data] }
  }
  return { base: [error.message] }
}

